import React from "react";
import Button from "@mui/material/Button";
import {useState} from "react";
import {useDispatch} from "react-redux";
import {updateUser} from "../../index";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import TextField from "@mui/material/TextField";
import {setModal} from "../../../../Common/App";
import {DialogCard} from "../../../../../Components";

export const UserEventModal = ({user}) => {

    const dispatch = useDispatch();
    const [disabled, setDisabled] = useState(false);
    const [event, setEvent] = useState(user?.event || '');

    const handleSubmit = async () => {
        setDisabled(true);
        await updateUser({dispatch, data:{id: user?.id, event: event}});
        dispatch(setModal({component:null, open:false}));
    };

    return(
        <DialogCard>
            <CardHeader title="Update User Event" />
            <CardContent>
                <TextField
                    fullWidth
                    label="Event"
                    value={event}
                    onChange={(e) => setEvent(e.target.value)}
                    placeholder="Enter event name"
                    variant="outlined"
                />
            </CardContent>
            <CardActions>
                <Button onClick={() => dispatch(setModal({component:null, open:false}))}>Cancel</Button>
                <Button disabled={disabled} variant="contained" color={'primary'} onClick={ handleSubmit }>Update Event</Button>
            </CardActions>
        </DialogCard>
    )
}